import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "BUY FROM THE VAULT",
    description:
      "Every minifigure and set in our inventory undergoes rigorous multi-point verification for authenticity, plastic grade integrity, and completeness.",
  },
  {
    number: "02",
    title: "FREE VALUATIONS",
    description:
      "Wondering what your childhood bin or pristine sealed sets are worth? Submit photos or videos to receive an expert market appraisal at zero cost.",
  },
  {
    number: "03",
    title: "TRADE & SELL DIRECT",
    description:
      "Skip auction fee cuts and platform hassle. Send us offers for your vintage collections with instant payouts or store credit trades.",
  },
];

export default function Chapters() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-24 md:py-32" data-testid="chapters-section">
      <div className="grid md:grid-cols-3 gap-px bg-[#DCD3C3] border border-[#DCD3C3]">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.number}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="bg-[#F3EDE3] p-10 md:p-12 group hover:bg-[#EAE2D5] transition-colors duration-500"
            data-testid={`chapter-${c.number}`}
          >
            <p className="font-mono text-xs uppercase tracking-[0.25em] gold-text">{c.number}</p>
            <h3 className="font-serif text-2xl md:text-3xl mt-6 group-hover:translate-x-1 transition-transform duration-500">{c.title}</h3>
            <p className="text-[#5C564C] text-sm leading-relaxed mt-5">{c.description}</p>
            <div className="mt-8 h-px w-12 bg-[#D4AF37] group-hover:w-full transition-all duration-700" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
